import { render } from "./ModalMockInviteLawyer.vue?vue&type=template&id=4fa54daf&scoped=true"
import script from "./ModalMockInviteLawyer.vue?vue&type=script&lang=js"
export * from "./ModalMockInviteLawyer.vue?vue&type=script&lang=js"

import "./ModalMockInviteLawyer.vue?vue&type=style&index=0&id=4fa54daf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa54daf"]])

export default __exports__